import { type FC } from "react";
import * as React from 'react';
import {
    Table,
    TableBody,
    TableHead,
    TableRow,
    IconButton,
    Stack,
    CircularProgress
} from '@mui/material';
import { CustomTableCell, CustomTableCellAddress, CustomTableCellHead, CustomTableContainer, CustomTableRow, CuttomButtonAdd, ImagesSmall } from "../../utils";
import IconAdd from "../../assets/images/icons/icon-add-black.png";
import IconDelete from "../../assets/images/icons/icon-delete.png";
import IconAccount from "../../assets/images/icons/icon-account.png";

interface TablesProps {
    rows: any;
    handleClick?: () => void;
    onDelete?: any;
    loading?: boolean;
}

const Tables: FC<TablesProps> = ({ rows, handleClick, onDelete, loading }) => {
    return (
        <Stack sx={{ mt: { xs: 5, sm: 10 } }}>
            <CustomTableContainer>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow sx={{ display: 'flex', columnGap: '12px' }}>
                            <CustomTableCellHead width={'80%'}>
                                Controller Wallet Address
                            </CustomTableCellHead>
                            <CustomTableCellHead width={'20%'}>
                                <CuttomButtonAdd onClick={handleClick} sx={{ p: 0 }}>
                                    <img src={IconAdd} alt="IconAdd" width={18} height={18} />&nbsp;
                                    Add
                                </CuttomButtonAdd>
                            </CustomTableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ?
                            <CustomTableRow>
                                <CustomTableCell width={'100%'}>
                                    <CircularProgress color="inherit" />
                                </CustomTableCell>
                            </CustomTableRow> :
                            rows.length > 0 ? rows.map((row: any, idx: number) => (
                                <CustomTableRow key={idx} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <CustomTableCellAddress width={'80%'}>
                                        <img src={IconAccount} alt="account" width={30} height={30} />&nbsp;
                                        {row}
                                    </CustomTableCellAddress>
                                    <CustomTableCell width={'20%'}>
                                        <IconButton onClick={() => onDelete(row)}>
                                            <ImagesSmall src={IconDelete} alt="IconDelete" />
                                        </IconButton>
                                    </CustomTableCell>
                                </CustomTableRow>
                            )) :
                                <CustomTableRow>
                                    <CustomTableCell width={'80%'}>
                                        No data
                                    </CustomTableCell>
                                    <CustomTableCell width={'20%'} />
                                </CustomTableRow>
                        }
                    </TableBody>
                </Table>
            </CustomTableContainer>
        </Stack>
    );
}

export default Tables;